import * as gs from "@ivanlog/gs";
import * as com from "../../plusx-lib/com/tmpls";
import { StatePaged } from "../../plusx-lib/states/abstracts/StatePaged";
import { App } from "../../plusx-lib/App";
import { LPXInfrastructure } from "../../plusx-lib/contracts/LPXInfrastructure";
import { Helper } from "../../plusx-lib/libs/Helper";

export class StateDashboard extends StatePaged<com.PageLPX> {
    static readonly StateName = "dashboard" ;
    private _refreshHandler:gs.HandlerAsync<undefined>;
    constructor() {
        super(com.PageLPX, "LPX DApp" , true)
        const ctrls = this.page.ctrls;
        this._refreshHandler = async ()=>{
            await this._refreshAsync();
        }
        ctrls.cmpWidgetLPXTable.ctrls.btnNewLPX.onclick=()=>{
            ctrls.blockMain.hide();
            ctrls.blockNewLPX.show();
            ctrls.cmpWgtLPXNew.resetAsync();
        }
        ctrls.cmpWgtLPXNew.onClose.addHandler(()=>{
            ctrls.blockMain.show();
            ctrls.blockNewLPX.hide();
        })
        ctrls.blockMain.show();
        ctrls.blockNewLPX.hide();
    }

    public async start() {     
        this.gui.showPage(this.page);
        this._hideLogoTask();
        await this._refreshAsync();
        return super.start();
    }


    public async afterStart()
    {
        App.chain.onChangeAccount.addHandler(this._refreshHandler);
        App.Inst.getInst(LPXInfrastructure).onRefresh.addHandler(this._refreshHandler);
        await super.afterStart();
    }

    public async stop(): Promise<void> {
        App.chain.onChangeAccount.removeHandler(this._refreshHandler);
        App.Inst.getInst(LPXInfrastructure).onRefresh.removeHandler(this._refreshHandler);
        await super.stop();
    }

    private async _hideLogoTask()
    {
        await Helper.awaitTime(300);
        this.page.ctrls.cmpHero.addClass('slim');
        await Helper.awaitTime(300);
        this.app.gui.layoutMain.ctrls.cmpHeader.addClass('lpx');
    }

    private async _refreshAsync()
    {
        const ctrls = this.page.ctrls;
        if (!this.app.chain.account)
        {
            ctrls.blockMain.show();
            ctrls.blockNewLPX.hide();
        }
        ctrls.cmpChart.ctrls.lTitle.hide();
        await ctrls.cmpWidgetLPXTable.refreshAsync(ctrls.cmpWidgetLPXDetails, ctrls.cmpChart, ctrls.cmpWidgetLPXCtrl);

    }
}
